<template>
  <Toast/>
  <div class="row">
    <div class="col">
      <h2 class="titre">Ajout Sous Categorie</h2>
    </div>
  </div>
  <ModifierChamps ref="modifierChamps" :isModifier="false"/>
  <ButtonBar @fermer="fermer" @ajouter="ajouter" :isSauvegardeEnCours="isSauvegardeEnCours"/>
  <DialogConfirmation ref="dialogConfirmation"/>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import ButtonBar from '../../../components/dossier/Ajouter/ButtonBarSousCategorie.vue'
import ModifierChamps from '../../../components/dossier/Modifier/ModifierChampsSousCategorie.vue'
import DialogConfirmation from '../../../components/Commun/DialogConfirmation.vue'

export default {
  name: "AjouterSousCategorie",
  components: {
    ButtonBar,
    ModifierChamps,
    DialogConfirmation,
  },
  data() {
    return {
      isSauvegardeEnCours: false,
    };
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      listeSousCategorie: 'sousCategorie/listeSousCategorie',
    })
  },
  beforeMount() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.commit('sousCategorie/SOUS_CATEGORIE_STORE_STATE_RESET');
    this.$store.dispatch('sousCategorie/resetSousCategorieStoredAction', {
      cleDossier: this.$route.params.cleDossier,
      siteDossier: this.$route.params.siteDossier,
    });
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Ajouter sousCategorie");
  },
  methods: {
    ajouter() {
      this.isSauvegardeEnCours = true;
      this.$store.commit('sousCategorie/UPDATE_SOUS_CATEGORIE', this.$refs.modifierChamps.getSousCategorieLocal());
      this.$store.dispatch('sousCategorie/ajouterSousCategorieAction', {
        sousCategorie: this.listeSousCategorie,
      }).then((res) => {
        this.$root.$refs.messagesComp.messagesList = res.data.messages
        if (res?.data?.messages.length == 0) {
          this.$toast.add( {
            severity: 'success',
            summary: 'Ajouter',
            detail: 'Le sousCategorie a été ajouté.',
            life: 6000
          });
          this.fermer();
        }
        else{
            this.$store.commit('sousCategorie/LISTE_SOUS_CATEGORIE',[]);
        }
        this.isSauvegardeEnCours = false;
      });
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  },
  beforeRouteLeave(to, from, next) {
    return this.$refs.dialogConfirmation.confirmer(next, this.$refs.modifierChamps.getSousCategorieLocal(), this.$refs.modifierChamps.getAncienSousCategorie());
  },
};
</script>